import React from "react";
import Button from "@amzn/meridian/button";

function ActionButton({ task }) {
  const {actionButton} = task;
  if (!actionButton) return null;
  if (!actionButton.buttonText) return null;
  if (actionButton.buttonText === "Edit in Dispatcher") return null;
  return (
    <Button type="tertiary" href={actionButton.url} onClick={(url) => window.open(url)}>
      {actionButton.buttonText}
    </Button>
  );
}

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/ActionButton.jsx